module.exports = __webpack_public_path__ + "static/img/dl-5.3389e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/dl-5.png
// module id = v0pO
// module chunks = 0